// @ts-ignore
const doctorPortalUrl = import.meta.env.VITE_DOCTOR_PORTAL_URL;

export const buildPortalUrl = ({
    mode,
    content,
    medium = "cta"
}: {
    mode: string;
    content: string;
    medium?: string;
}) => {
    return attachUtmParamsToUrl({
        baseUrl: doctorPortalUrl,
        mode,
        content,
        medium
    });
};

export const buildScheduleDemoUrl = () => {
    // @ts-ignore
    return import.meta.env.VITE_SCHEDULE_DEMO_URL;
};

// helper function
const attachUtmParamsToUrl = ({
    mode,
    baseUrl,
    content,
    medium = "cta"
}: {
    baseUrl: string;
    mode: string;
    content: string;
    medium?: string;
}) => {
    const currentYear = new Date().getFullYear();
    const params = new URLSearchParams({
        mode: mode,
        utm_source: "landing_page",
        utm_medium: medium,
        utm_campaign: `onboarding_${currentYear}`,
        utm_content: content
    });

    const cleanBaseUrl = baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;
    return `${cleanBaseUrl}/?${params.toString()}`;
};
